export function DataTable({ columns, rows, rowKey = "id", onRowClick, empty = "No records found" }) {
  return (
    <div className="border border-border rounded-2xl overflow-hidden bg-card card-soft">
      <div className="overflow-x-auto relative">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border bg-secondary">
              {columns.map((c) => (
                <th key={c.key} className="text-left font-semibold text-muted-foreground uppercase tracking-wider text-[11px] px-4 py-3 whitespace-nowrap">
                  {c.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className="px-4 py-12 text-center text-muted-foreground">{empty}</td>
              </tr>
            ) : (
              rows.map((row, i) => (
                <tr key={row[rowKey] || i} data-testid={`row-${row[rowKey] || i}`}
                  onClick={() => onRowClick && onRowClick(row)}
                  className={`border-b border-border/60 last:border-0 transition-colors hover:bg-secondary/70 ${onRowClick ? "cursor-pointer" : ""}`}>
                  {columns.map((c) => (
                    <td key={c.key} className="px-4 py-3 align-middle whitespace-nowrap">
                      {c.render ? c.render(row, i) : row[c.key] ?? "—"}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
